import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { TracewayProvider } from '@tracewayapp/react';
import packageJson from '../package.json';
//
import App from './App';

const TRACEWAY_CONNECTION_STRING = import.meta.env.PROD
  ? 'ifta@https://cloud.tracewayapp.com/api/report'
  : 'ifta@http://localhost:8082/api/report';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <TracewayProvider
    connectionString={TRACEWAY_CONNECTION_STRING}
    options={{
      version: packageJson.version,
      // Axios 5xx errors are already captured with a distributedTraceId by the
      // response interceptor in src/utils/axios.ts: drop the duplicate,
      // unlinked capture from the SDK's global unhandledrejection handler.
      beforeCapture: (exception) =>
        !(!exception.distributedTraceId && /status code 5\d{2}/.test(exception.stackTrace)),
    }}
  >
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </TracewayProvider>
);
